import React from 'react';
import { RxHamburgerMenu } from 'react-icons/rx';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useVehicles } from '../../hooks/useVehicles';
import NotificationBell from '../notifications/NotificationBell';
import toast from 'react-hot-toast';

const pageTitles = {
  '/dashboard': 'Dashboard', '/vehicles': 'Vehicles', '/drivers': 'Drivers',
  '/trips': 'Trips', '/leaves': 'Leave Management', '/reports': 'Reports',
  '/expenses': 'Expenses', '/notifications': 'Notifications', '/profile': 'Profile',
};

export default function Navbar({ onMenuClick }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const {
    vehicles,
    selectedVehicle,
    setSelectedVehicle,
    setDriverVehicleForToday,
    activeVehicleSession,
  } = useVehicles();
  const isDriver = user?.role === 'driver';
  const switchLocked =
    isDriver &&
    Boolean(selectedVehicle?.id) &&
    activeVehicleSession?.can_switch_active_vehicle === false;
  const title = pageTitles[pathname] || 'Mololine';

  return (
    <div className="navbar">
      <button className="navbar-burger" onClick={onMenuClick}><RxHamburgerMenu size={22} /></button>
      <span className="navbar-title">{title}</span>

      {vehicles?.length > 0 && (
        <select
          className="form-control navbar-vehicle-select"
          value={selectedVehicle?.id || ''}
          onChange={(e) => {
            const picked = vehicles.find((v) => String(v.id) === String(e.target.value));
            if (!picked) return;
            if (isDriver) {
              if (switchLocked && String(picked.id) !== String(selectedVehicle?.id)) {
                toast.error('Active vehicle already selected for today. Log out and sign in again to switch vehicle.');
                return;
              }
              setDriverVehicleForToday(picked, user?.id).catch(() => {});
              return;
            }
            else setSelectedVehicle(picked);
          }}
        >
          {vehicles.map(v => (
            <option key={v.id} value={v.id}>{v.registration_number} — {v.make} {v.model}</option>
          ))}
        </select>
      )}

      {switchLocked && (
        <span style={{ fontSize: '0.8rem', color: 'var(--gray-500)', marginLeft: '0.5rem' }}>
          Active vehicle already selected for today. Log out and sign in again to switch vehicle.
        </span>
      )}

      <NotificationBell />
    </div>
  );
}